import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAiChatMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.AiChats_Set_Input>;
  id: Types.Scalars['String']['input'];
}>;


export type UpdateAiChatMutation = { __typename?: 'mutation_root', update_aiChats_by_pk?: { __typename?: 'aiChats', id: string, feedback?: string | null, private: boolean, helpful?: boolean | null, moreInput?: boolean | null, aiResponseEnabled: boolean } | null };


export const UpdateAiChatDocument = gql`
    mutation updateAiChat($set: aiChats_set_input, $id: String!) {
  update_aiChats_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    feedback
    private
    helpful
    moreInput
    aiResponseEnabled
  }
}
    `;
export type UpdateAiChatMutationFn = Apollo.MutationFunction<UpdateAiChatMutation, UpdateAiChatMutationVariables>;

/**
 * __useUpdateAiChatMutation__
 *
 * To run a mutation, you first call `useUpdateAiChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiChatMutation, { data, loading, error }] = useUpdateAiChatMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAiChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiChatMutation, UpdateAiChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiChatMutation, UpdateAiChatMutationVariables>(UpdateAiChatDocument, options);
      }
export type UpdateAiChatMutationHookResult = ReturnType<typeof useUpdateAiChatMutation>;
export type UpdateAiChatMutationResult = Apollo.MutationResult<UpdateAiChatMutation>;
export type UpdateAiChatMutationOptions = Apollo.BaseMutationOptions<UpdateAiChatMutation, UpdateAiChatMutationVariables>;